'use client';

import { mxpIframeStore } from '@lib/stores/mxp-iframe-store';
import Link from 'next/link';

import type { ComponentProps, FC, MouseEvent } from 'react';

export type HistoryAwareBackLinkProps = ComponentProps<typeof Link> & {
  tryHistoryBack?: boolean;
};

export const HistoryAwareBackLink: FC<HistoryAwareBackLinkProps> = ({
  tryHistoryBack,
  onClick: parentOnClick,
  ...props
}) => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (mxpIframeStore.navigateBack) {
      event.preventDefault();
      mxpIframeStore.navigateBack();
      return;
    }

    if (tryHistoryBack && history.length > 1) {
      event.preventDefault();

      parentOnClick?.(event);

      history.back();
      return;
    }

    parentOnClick?.(event);
  };

  return <Link {...props} onClick={handleClick} />;
};
